//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowContentMediaDx2",

    props: {
        ...defaultBlockProps,
    },

    data: () => ({}),
};
